export default "__VITE_ASSET__BJfyfiFu__"